/* ═══════════════════════════════════════════════════════════════════════════
   Águas de Ipanema — Collection 2026
   Drawer de filtros, drawer/bottom sheet de ordenação e faixa de preço.

   Os filtros são os facets NATIVOS do Shopify: o formulário só monta a query
   string com os param_name/value que o próprio Shopify renderizou e navega.
   Nada é filtrado no cliente.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.__aipCollection2026) return;
  window.__aipCollection2026 = true;

  var LOCK = 'aip-drawer-open';
  var aberto = null;
  var ultimoFoco = null;

  function abrir(drawer, gatilho) {
    if (!drawer) return;
    fechar();
    aberto = drawer;
    ultimoFoco = gatilho || null;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.classList.add(LOCK);
    if (gatilho) gatilho.setAttribute('aria-expanded', 'true');
    var alvo = drawer.querySelector('.aip-drawer__close');
    if (alvo) alvo.focus();
  }

  function fechar() {
    if (!aberto) return;
    aberto.setAttribute('aria-hidden', 'true');
    aberto.classList.remove('is-open');
    document.body.classList.remove(LOCK);
    document.querySelectorAll('[data-aip-open-filters], [data-aip-open-sort]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (ultimoFoco) { ultimoFoco.focus(); ultimoFoco = null; }
    aberto = null;
  }

  /* ── Aplicar filtros: monta a URL com os facets marcados ─────────────────── */
  function aplicar(form) {
    if (!form) return;
    var base = form.getAttribute('action') || window.location.pathname;
    var params = new URLSearchParams();

    new FormData(form).forEach(function (valor, chave) {
      var v = String(valor).trim();
      if (v === '') return;
      params.append(chave, v);
    });

    params.delete('page');
    var layout = document.querySelector('.aip-col-layout');
    if (layout) layout.classList.add('is-loading');
    var qs = params.toString();
    window.location.href = qs ? base + '?' + qs : base;
  }

  /* Sidebar do desktop: sem botão "Aplicar" — cada marcação já navega.
     Os campos de preço passam por um respiro para o usuário digitar os dois. */
  var timerAuto = null;
  function aplicarComAtraso(form, atraso) {
    if (timerAuto) clearTimeout(timerAuto);
    timerAuto = setTimeout(function () { aplicar(form); }, atraso);
  }

  /* ── Faixa de preço: dois handles + campos numéricos sincronizados ───────── */
  function initPreco(box) {
    var lo = box.querySelector('.aip-price__range--lo');
    var hi = box.querySelector('.aip-price__range--hi');
    var loInput = box.querySelector('.aip-price__input--lo');
    var hiInput = box.querySelector('.aip-price__input--hi');
    var max = parseInt(box.dataset.max, 10) || 0;
    if (!lo || !hi || !max) return;

    function pintar() {
      box.style.setProperty('--aip-range-lo', (lo.value / max) * 100 + '%');
      box.style.setProperty('--aip-range-hi', (hi.value / max) * 100 + '%');
    }

    function daBarra() {
      var a = parseInt(lo.value, 10);
      var b = parseInt(hi.value, 10);
      if (a > b) { var t = a; a = b; b = t; lo.value = a; hi.value = b; }
      /* campo vazio = sem limite; só grava quando o handle saiu da ponta */
      loInput.value = a > 0 ? a : '';
      hiInput.value = b < max ? b : '';
      pintar();
    }

    function dosCampos() {
      var a = parseInt(loInput.value, 10);
      var b = parseInt(hiInput.value, 10);
      lo.value = isNaN(a) ? 0 : Math.min(Math.max(a, 0), max);
      hi.value = isNaN(b) ? max : Math.min(Math.max(b, 0), max);
      pintar();
    }

    lo.addEventListener('input', daBarra);
    hi.addEventListener('input', daBarra);
    loInput.addEventListener('change', dosCampos);
    hiInput.addEventListener('change', dosCampos);
    pintar();
  }

  /* <summary> tem role=button nativo, mas não expõe aria-expanded sozinho;
     o atributo nasce no Liquid e é mantido em sincronia aqui. */
  function sincronizarAria(details) {
    var sum = details.querySelector('.aip-filter__group-title');
    if (sum) sum.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  /* Altura real do header sticky. A variável --header-height do tema diz 120px,
     mas a seção sticky inteira mede 175px (a barra de anúncios fica dentro
     dela) — usar a variável fazia a sidebar entrar 31px por baixo do header. */
  /* Largura da barra de rolagem. 100vw a INCLUI, então qualquer elemento que
     sangra com width:100vw fica mais largo que a área visível em navegador com
     barra clássica (Windows, ou Mac com "sempre mostrar") — é o que cortava o
     card da direita. Guardado em --aip-sb para o CSS descontar. */
  function medirBarra() {
    var sb = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.documentElement.style.setProperty('--aip-sb', sb + 'px');
  }

  function medirHeader() {
    var h = document.querySelector('#shopify-section-header') || document.querySelector('.header');
    if (!h) return;
    var altura = Math.round(h.getBoundingClientRect().height);
    if (altura > 0) {
      document.documentElement.style.setProperty('--aip-header-h', altura + 'px');
    }
  }

  function init() {
    medirBarra();
    medirHeader();
    document.querySelectorAll('[data-aip-price]').forEach(initPreco);
    document.querySelectorAll('.aip-filter__group').forEach(function (d) {
      sincronizarAria(d);
      if (d.dataset.aipAria === '1') return;
      d.dataset.aipAria = '1';
      d.addEventListener('toggle', function () { sincronizarAria(d); });
    });
  }

  document.addEventListener('click', function (e) {
    var abrirFiltros = e.target.closest('[data-aip-open-filters]');
    if (abrirFiltros) {
      e.preventDefault();
      abrir(document.getElementById('aip-filter-drawer'), abrirFiltros);
      return;
    }

    var abrirSort = e.target.closest('[data-aip-open-sort]');
    if (abrirSort) {
      e.preventDefault();
      abrir(document.getElementById('aip-sort-drawer-2026'), abrirSort);
      return;
    }

    if (e.target.closest('[data-aip-drawer-close]')) {
      e.preventDefault();
      fechar();
      return;
    }

    var aplicarBtn = e.target.closest('[data-aip-apply]');
    if (aplicarBtn) {
      e.preventDefault();
      /* O formulário do drawer, nunca o da sidebar: os dois existem na página. */
      var escopo = aplicarBtn.closest('.aip-drawer') || document;
      aplicar(escopo.querySelector('[data-aip-filter-form]'));
      return;
    }

    var opt = e.target.closest('[data-aip-sort]');
    if (opt) {
      e.preventDefault();
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', opt.dataset.aipSort);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && aberto) { fechar(); return; }
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var opt = e.target.closest && e.target.closest('[data-aip-sort]');
    if (!opt) return;
    e.preventDefault();
    opt.click();
  });

  /* Sidebar (desktop): marcar/desmarcar aplica na hora — sem botão intermediário */
  document.addEventListener('change', function (e) {
    var campo = e.target;
    if (!campo || !campo.closest) return;
    var form = campo.closest('[data-aip-auto-apply]');
    if (!form) return;
    if (campo.type === 'checkbox' || campo.type === 'range') {
      aplicarComAtraso(form, 120);
    } else if (campo.classList.contains('aip-price__input')) {
      aplicarComAtraso(form, 600);
    }
  });

  /* Enter dentro do formulário aplica em vez de submeter cru */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-aip-filter-form]');
    if (!form) return;
    e.preventDefault();
    aplicar(form);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', function () { medirBarra(); medirHeader(); });
  window.addEventListener('load', function () { medirBarra(); medirHeader(); });

  /* Editor de temas: a seção é re-renderizada sem recarregar a página */
  document.addEventListener('shopify:section:load', init);
})();
